export class BreakpointsService {
  getBreakPoints(){
    return {'$xs-max-width': 479,
    '$sm-min-width' : 480,
    '$sm-max-width' : 767,
    '$md-min-width' : 768,
    '$md-max-width' : 979,
    '$lg-min-width': 980,
    '$lg-max-width': 1199,
    '$xl-min-width': 1200}
  }


}
